import React from "react";
import PrivacyPolicyENG from "./privacy-policy-text/privacy-policy-eng";
import PrivacyPolicyKAZ from "./privacy-policy-text/privacy-policy-kaz";
import PrivacyPolicyRUS from "./privacy-policy-text/privacypolicy-rus";
import s from "./privacy-policy.module.scss";

const PrivacyPolicy = (props) => {

    const getPrivacyPolicyText = (lang) => {
        switch(lang){
            case 'RUS':
                return <PrivacyPolicyRUS />
            case 'KAZ':
                return <PrivacyPolicyKAZ />
            case 'ENG': 
                return <PrivacyPolicyENG />
            default:
                return <PrivacyPolicyRUS />
        }
    }

    const text = getPrivacyPolicyText(props.selectedLanguage)

    return (
        <div className={s.PrivacyPolicy}>
            <div className={s.content}>
                <h1>{props.getValue("PRIVACY_POLICY_2")}</h1>
                {text}
            </div>
        </div>
    )
}

export default PrivacyPolicy;